import { useState, useEffect } from "react";
import Marquee from "react-fast-marquee";
import { Bell, ExternalLink, Info, Megaphone } from "lucide-react";
import { Link } from "react-router-dom";

const NoticeBar = ({ notices = [] }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="relative rounded-lg overflow-hidden  mb-8 mt-4 border border-gray-200">
      <div className="flex items-center">
        {/* Left heading section */}
        <div className="bg-primary flex items-center text-white px-4 py-3">
          <Megaphone size={20} className="mr-2" />
          <p className="font-semibold">সর্বশেষ:</p>
        </div>

        {/* Marquee section */}
        <div
          className="flex-1 relative"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Marquee
            className="text-gray-800 font-medium py-3 bg-white"
            gradient={false}
            speed={isHovered ? 20 : 50}
            pauseOnHover={true}
          >
            {notices
              ?.slice()
              ?.reverse()
              ?.map((notice) => (
                <Link
                  className="mr-12 hover:text-primary transition-colors duration-200 flex items-center"
                  key={notice.id || Math.random()}
                  to="/media/latest-notice"
                >
                  <Bell size={16} className="mr-2 text-primary" />
                  {notice.title}
                  <ExternalLink size={14} className="ml-1 text-gray-400" />
                </Link>
              ))}
          </Marquee>
        </div>

        {/* View all button */}
        <Link
          to="/media/latest-notice"
          className="bg-indigo-50 hover:bg-indigo-100 text-primary px-4 py-3 flex items-center transition-colors duration-200 whitespace-nowrap"
        >
          <Info size={18} className="mr-1" />
          <span className="font-medium text-sm">View All</span>
        </Link>
      </div>
    </div>
  );
};

export default NoticeBar;
